import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Process from "@/pages/Process";
import Apply from "@/pages/Apply";
import ApplyChooser from "@/pages/ApplyChooser";
import ApplyChat from "@/pages/ApplyChat";
import ApplyWhatsApp from "@/pages/ApplyWhatsApp";
import Contact from "@/pages/Contact";
import News from "@/pages/News";
import Persona from "@/pages/Persona";
import InvoiceFinancing from "@/pages/InvoiceFinancing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminContent from "@/pages/AdminContent";
import AdminEligibility from "@/pages/AdminEligibility";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/process" element={<Process />} />
            <Route path="/apply" element={<ApplyChooser />} />
            <Route path="/apply-form" element={<Apply />} />
            <Route path="/apply-chat" element={<ApplyChat />} />
            <Route path="/apply-whatsapp" element={<ApplyWhatsApp />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/news" element={<News />} />
            <Route path="/for/:slug" element={<Persona />} />
            <Route path="/salaried" element={<Persona />} />
            <Route path="/self-employed" element={<Persona />} />
            <Route path="/business-owners" element={<Persona />} />
            <Route path="/property-investors" element={<Persona />} />
            <Route path="/invoice-financing-bangalore" element={<InvoiceFinancing />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/eligibility" element={<AdminEligibility />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
